import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Categories from '../Categories';
import Modifiers from '../Modifiers/Modifiers';
import NewCategoryModal from '../NewCategoryModal';
import Loading from '../../../components/Loading';
import ReorderModal from '../ReorderModal';
import { onCategoriesChangeStatus, onCategoriesLoad } from '../../../store/Categories/actions';
import '../modal.css';
import Button from '../../../components/Button/Button';
import { InputSearch } from '../../../components/InputSearch';
import { useParams } from 'react-router';
import { useAddNewCategory, useGetMenu, useGetCategories } from '../../../network';
import { useQueryClient } from '@tanstack/react-query';
import { Breadcrumbs } from '../../../components/Breadcrumbs';
import { PuffLoader } from 'react-spinners';
import { useSetFilters } from '../../../hooks/useSetFilters';
import {useDebounce} from "../../../hooks/useDebounce";
import {FormField} from "../../../components/FormField";
import { MenuCategoryItems } from '../CategoryItems';
import classnames from 'classnames';
import { CustomSelect } from '../../../components/Shared/CustomSelect';

const filteringData = (value, data) => data?.filter(
    (item) => item.name.toLowerCase().includes(value.toLowerCase()) ||
        item.dishes.some(({ name = '', title = '' }) => (title? title.toLowerCase(): name.toLowerCase()).includes(value.toLowerCase())));
export const MenuCategory = () => {
    const { location } = useHistory();
    const { t } = useTranslation();
    const { slug } = useParams();
    const queryClient = useQueryClient();
    const setFilters = useSetFilters();
    const searchParams = new URLSearchParams(location.search);
    const statusParams = searchParams.get("status");
    const searchTerm = searchParams.get("term") || '';
    const searchCategory = searchParams.get("category") || "";
    const search = useDebounce(searchTerm, 200) || "";
    const isCategories = location.pathname.includes('categories')

    const { data: menuInfo = {} } = queryClient.getQueryData(['menu-list', slug]) || {};
    const { isLoading: isMenuLoading } = useGetMenu({ slug, config: { enabled: !!menuInfo } });

    const { data: { data: categories = {} } = {}, isLoading: isCategoriesLoading, isFetching: isCategoriesFetching } = useGetCategories(
        { slug, filters:{ status: isCategories && statusParams || 'active' }});
    const { mutate: addNewCategory } = useAddNewCategory({ slug });
    const [isAddCategoryModalOpened, setIsAddCategoryModalOpened] = useState(false);

    const pages = [
        { name: t('Menu'), path: '/chain/menu' },
        { name: menuInfo.name, path: `/chain/menu/${slug}/categories` },
    ];

    const loading = isMenuLoading || isCategoriesLoading;

    const [categoryName, setCategoryName] = useState('');
    const [hovered, setHovered] = useState(false);
    const [reorderModal, setReorderModal] = useState(false);
    const dispatch = useDispatch();

    const BtnColor_gray = 'text-white bg-gray-900 hover:bg-gray-700';
    const BtnColor_blue = 'text-white bg-purple-500 hover:bg-purple-300 focus:outline-none';
    const BtnColor_disabled = 'text-white bg-gray-500 hover:bg-gray-500 focus:outline-none';

    const {  modalEditCategory } = useSelector(({ categories }) => ({
        modalEditCategory: categories.modalEditCategory,
    }));


    const activeHandleChange = (newValue) => {
        dispatch(onCategoriesChangeStatus(newValue.value));
        setFilters({ status: newValue.value });
    };

    const categoriesHandleChange = (newValue) => {
        newValue.value === 'all'
            ? setFilters({ category: '' })
            : setFilters({ category: newValue.value })
    };

    const onSearch = (e) => {
        setFilters({ term: e.target.value });
    };

    const activeFilterOptions = [
        { value: 'active', label: t('menu_status.active') },
        { value: 'archived', label: t('menu_status.archived') },
    ];

    const categoriesFilterOptions =
        categories.data && categories.data.length
            ? categories.data.map((item) => ({
                  value: item.name,
                  label: item.name,
              }))
            : [];

    const categoriesOptions = [{ value: 'all', label: t('All Categories') }, ...categoriesFilterOptions];
    const categoriesOptionsDefault = !searchCategory? categoriesOptions[0]: { value: searchCategory, label: searchCategory }

    const reorderModalOpenHandle = () => {
        setReorderModal((prev) => !prev);
    };
    const reorderModalCloseHandle = () => {
        setReorderModal((prev) => !prev);
    };
    const onSaveCategoryPosition = () => {
        reorderModalCloseHandle();
        dispatch(onCategoriesLoad());
    };
    const onOpenNewCategory = () => {
        setCategoryName('');
        setIsAddCategoryModalOpened(true);
    };
    const onCloseNewCategory = () => {
        setCategoryName('');
        setIsAddCategoryModalOpened(false);
    };
    const onChangeCategoryName = (e) => {
        setCategoryName(e.target.value);
    };
    const onSaveCategory = () => {
        onCloseNewCategory();
        addNewCategory({ name: categoryName, menu_id: slug });
    };
    let filteredCategory = [];

    if(search) {
        filteredCategory = filteringData(search, categories.data);
    }

    if(searchCategory) {
        filteredCategory = filteringData(searchCategory, categories.data);
    }

    if(searchCategory && search) {
        const temp = filteringData(search, categories.data);
        filteredCategory = filteringData(searchCategory, temp);
    }

    if(!search && !searchCategory) {
        filteredCategory = categories.data;
    }

    const isPOS = menuInfo.type === 'pos';

    return (
        <div className="max-w-screen-lg px-4 sm:px-8 lg:px-10 xl:px-12">
            <Breadcrumbs pages={pages} />
            <Loading loading={loading}>
                <div className="flex gap-5 flex-col items-start justify-between md:flex-row md:items-center mt-8 mb-5 relative">
                    <div className="flex items-center">
                        <Button isUpperCase={false} type="link" to={`/chain/menu/${slug}/items`} fontWeight="font-normal" tracing="tracking-normal" color={isCategories && "bg-gray-300"} className="h-9 rounded-r-none px-10 font-bold">
                            {t('Items')}
                        </Button>
                        <Button isUpperCase={false} type="link" to={`/chain/menu/${slug}/modifiers`} fontWeight="font-normal" tracing="tracking-normal" color="bg-gray-300" className="h-9 rounded-l-none rounded-r-none  px-10 font-bold">
                            {t('Modifiers')}
                        </Button>
                        <Button isUpperCase={false} type="link" to={`/chain/menu/${slug}/categories`} fontWeight="font-normal" tracing="tracking-normal" color={!isCategories && "bg-gray-300"} className="h-9 rounded-l-none border-l-2 px-10 font-bold">
                            {t('Categories')}
                        </Button>
                        {!isCategoriesLoading && isCategoriesFetching && (
                            <div className="ml-4 mb-1">
                                <PuffLoader color="#7A5AF8" size={36} />
                            </div>
                        )}
                    </div>

                    {isPOS && (
                        <div className={`absolute w-96 right-0 -top-24 ${hovered ? 'show' : 'hide'}`}>
                            <div className={`font-medium text-xs border-none px-2 py-1 focus:ring-gray-200 focus:border-gray-100 bg-gray-100 block  shadow-sm rounded-md`}>
                                <p className="mb-1 leading-4">{t('You cannot add new items or categories to a menu that has been imported from a POS system.')}</p>
                                <p>{t('To create a manual menu, please return back to the main menu section to disable your POS menu.')}</p>
                            </div>
                        </div>
                    )}

                    <div>
                        <button
                            onClick={isPOS ? null : onOpenNewCategory}
                            onMouseOver={isPOS ? () => setHovered(true) : null}
                            onMouseOut={isPOS ? () => setHovered(false) : null}
                            className={`h-9 items-center px-4 py-1.5 mr-2 border border-transparent rounded-md font-semibold text-sm ${isPOS ? BtnColor_disabled : BtnColor_gray}`}
                        >
                            {t('Add Category')}
                        </button>
                        {isPOS ? (
                            <button
                                onMouseOver={() => setHovered(true)}
                                onMouseOut={() => setHovered(false)}
                                className={`h-9 items-center px-4 py-1.5 border border-transparent rounded-md font-semibold text-sm ${BtnColor_disabled}`}
                            >
                                {t('Add Item')}
                            </button>
                        ) : (
                            <Button type="link" to={`/chain/menu/${slug}/dishes/create`} isUpperCase={false} className="font-bold">
                                {t('Add Item')}
                            </Button>
                        )}

                        <NewCategoryModal loading={loading} visible={isAddCategoryModalOpened} onClose={onCloseNewCategory} onChangeName={onChangeCategoryName} onSave={onSaveCategory} />
                    </div>
                </div>

                <div className={classnames("flex flex-col md:flex-row gap-4 mb-5", { ["justify-between"]: isCategories })}>
                    <div className="flex">
                        <FormField >
                            <CustomSelect
                                className="text-left w-44 mr-2.5"
                                onChange={categoriesHandleChange}
                                isLoading={loading}
                                options={categoriesOptions}
                                defaultValue={categoriesOptionsDefault}
                                isSearchable={true}
                            />
                        </FormField>
                        <FormField>
                            <CustomSelect
                                className="text-left w-32"
                                onChange={activeHandleChange}
                                isLoading={loading}
                                options={activeFilterOptions}
                                defaultValue={activeFilterOptions[0]}
                                isSearchable={false}
                            />
                        </FormField>

                    </div>

                    <div className="flex items-center gap-2">
                    <FormField><InputSearch onChange={onSearch} value={searchTerm} className="w-40 h-9" /></FormField>
                        {isCategories && (
                            <button onClick={reorderModalOpenHandle} className={`h-9 items-center px-7 py-1.5 border border-transparent rounded-md font-semibold text-sm  ${BtnColor_blue}`}>
                                {t('Reorder')}
                            </button>
                        )}

                        <ReorderModal loading={loading} visible={reorderModal} onClose={reorderModalCloseHandle} onSave={onSaveCategoryPosition} categories={categories} />
                    </div>
                </div>
                {isCategories ? <Categories loading={loading} filteredCategory={filteredCategory} modalEditCategory={modalEditCategory} /> : <MenuCategoryItems items={filteredCategory}/>}
            </Loading>
        </div>
    );
};
